import "./CaseStudies.module.css";
import Header from "@/reusable_sections/Header";
import Intro from "./sections/Intro";
import CaseStudies from "./sections/CaseStudies";
import CaseStudy from "./sections/CaseStudy";
import Footer from "@/reusable_sections/Footer";
export default function CaseStudiesPage() {
  return <div>
      <Header />
      <Intro />
      <CaseStudies />
      <CaseStudy />
      <Footer />
    </div>;
}